export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14795.b371b5dd.jpg";